import React from "react";
import PropTypes from "prop-types";

import { css } from "@oddcommon/utils";
import styles from "./LabeledContent.module.scss";

export default function LabeledContent({ label, children, className, ...props }) {
  return (
    <div className={css(styles.base, className)} {...props}>
      {label && (
        <p className={styles.label}>
          <span className={styles.slash}>&#824;</span>&nbsp;&nbsp;{label}
        </p>
      )}
      <div>{children}</div>
    </div>
  );
}

LabeledContent.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node.isRequired,
};
